import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "step-body"
}
const _hoisted_2 = { class: "body-content review-content" }
const _hoisted_3 = { class: "form-group table-container" }
const _hoisted_4 = { id: "review-request" }
const _hoisted_5 = { class: "value-display" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "value-display" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "value-display" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "value-display" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 0,
  class: "form-check"
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = {
  key: 1,
  class: "submit-error"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "step-btns"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          inverse: true
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "step-title" }, "Review Request", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "step-desc" }, " Your request has not yet been submitted. Confirm the information is correct. ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                  _createElementVNode("th", null, "School Name:"),
                  _createElementVNode("th", null, "Funding Term:"),
                  _createElementVNode("th", null, "Enrollment:"),
                  _createElementVNode("th", null, "Requested Amount:")
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DISBURSEMENTS, (disbursement, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[4] || (_cache[4] = _createElementVNode("label", null, "School Name:", -1)),
                          _createElementVNode("p", _hoisted_6, _toDisplayString(disbursement.schoolName), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Funding Term:", -1)),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(disbursement.enrollmentTerm), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Enrollment:", -1)),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(disbursement.enrollmentStatusName), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Requested Amount:", -1)),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(disbursement.requestedAmount), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          (_ctx.isParentLOC)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "parentAttestation",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parentConsent) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.parentConsent]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "parentAttestation"
                }, " By checking this box, you affirm that you are the student's parent or legal guardian and that you claim the student as a dependent on your tax return. ", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "confirmRequest",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reviewConfirmation) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.reviewConfirmation]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              class: "form-check-label",
              for: "confirmRequest"
            }, " I confirm the above information. ", -1))
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.postErrors.length <= 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Something has gone wrong submitting your request. If you continue to receive this error, please contact support. "))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                      _cache[11] || (_cache[11] = _createElementVNode("p", null, " Something has gone wrong submitting your request. If you continue to receive this error, please contact support. ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postErrors, (error, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            disabled: _ctx.loading || _ctx.previousButtonDisabled,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('goback')), ["prevent"]))
          }, " Go Back ", 8, _hoisted_19),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm cuscd-button-color-cta",
            disabled: 
          !_ctx.reviewConfirmation || _ctx.loading || _ctx.submittingRequest || (_ctx.isParentLOC && !_ctx.parentConsent)
        ,
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRequest && _ctx.submitRequest(...args)), ["prevent"]))
          }, " Submit ", 8, _hoisted_20)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}